import type { ReactNode } from 'react';
import { FrostedSurface, YStack } from 'smoothie';

import {
    CHAT_MESSAGE_PADDING_HORIZONTAL,
    CHAT_WIDGET_MAX_WIDTH,
} from '../layout/ChatLayout';

interface SproutWidgetFrameProps {
    children: ReactNode;
    /** Wrap content in the shared frosted chat surface. */
    frosted?: boolean;
    /**
     * Inner padding when `frosted` is true. Use `0` when children manage their
     * own padding (e.g. full-bleed list rows inside the frosted shell).
     */
    contentPadding?: number;
}

/**
 * Shared shell for Sprout chat widgets: centered, capped at
 * {@link CHAT_WIDGET_MAX_WIDTH}, with optional frosted chrome.
 */
export const SproutWidgetFrame = ({
    children,
    frosted = false,
    contentPadding = 16,
}: SproutWidgetFrameProps) => {
    const content = frosted ? (
        <FrostedSurface width="100%" maxWidth={CHAT_WIDGET_MAX_WIDTH}>
            <YStack width="100%" padding={contentPadding}>
                {children}
            </YStack>
        </FrostedSurface>
    ) : (
        <YStack width="100%" maxWidth={CHAT_WIDGET_MAX_WIDTH}>
            {children}
        </YStack>
    );

    return (
        <YStack
            width="100%"
            paddingHorizontal={CHAT_MESSAGE_PADDING_HORIZONTAL}
            alignItems="center"
        >
            {content}
        </YStack>
    );
};
